import { CM0017_3_2SliceType } from './../type/Presenter';
import { createSlice } from '@reduxjs/toolkit';

const initialState: CM0017_3_2SliceType = {
    loading: false,
    isVisible: false,
    refresh: false,
    typeModal: false,
    parentCode: {
        documentOutsourceCostDataSummaryId: null,
        categoryId: null,
    },
    isUpdate: true,
    modalTitle: null,
};

export const cm0017_3_2Slice = createSlice({
    name: 'cm0017_3_2',
    initialState,
    reducers: {
        resetCM0017_3_2: () => initialState,
        setLoadingCM0017_3_2: (state, action) => {
            state.loading = action.payload;
        },
        setIsVisibleCM0017_3_2: (state, action) => {
            state.isVisible = action.payload;
        },
        setRefreshCM0017_3_2: (state) => {
            state.refresh = !state.refresh;
        },
        setTypeModalCM0017_3_2: (state, action) => {
            state.typeModal = action.payload;
        },
        setParentCodeCM0017_3_2: (state, action) => {
            state.parentCode = action.payload;
        },
        setIsUpdate: (state, action) => {
            state.isUpdate = action.payload;
        },
        setModalTitleCM0017_3_2: (state, action) => {
            state.modalTitle = action.payload;
        },
    },
});

export const {
    setIsUpdate,
    setLoadingCM0017_3_2,
    setIsVisibleCM0017_3_2,
    resetCM0017_3_2,
    setRefreshCM0017_3_2,
    setTypeModalCM0017_3_2,
    setParentCodeCM0017_3_2,
    setModalTitleCM0017_3_2,
} = cm0017_3_2Slice.actions;

export default cm0017_3_2Slice.reducer;
